import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { TooltipTrigger } from '../Tooltip/TooltipTrigger';
import './NavigationMainButton.css';

/** Icon button in the navigation bar's right-side actions area. Optionally shows a Badge overlay. */
export type NavigationMainButtonProps = {
  children: ReactNode;
  badge?: ReactNode;
  className?: string;
  /** Hover tooltip from `aria-label`. Defaults to true. */
  showTooltip?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export function NavigationMainButton({
  children,
  badge,
  className = '',
  type = 'button',
  'aria-label': ariaLabel,
  disabled,
  showTooltip = true,
  ...rest
}: NavigationMainButtonProps) {
  const button = (
    <button
      type={type}
      className={['spark-navigation-main-button', className].filter(Boolean).join(' ')}
      aria-label={ariaLabel}
      disabled={disabled}
      {...rest}
    >
      <span className="spark-navigation-main-button-content">{children}</span>
    </button>
  );

  const withTooltip = Boolean(ariaLabel) && showTooltip;

  return (
    <div className="spark-navigation-main-button-wrap">
      {withTooltip ? (
        <TooltipTrigger text={ariaLabel} placement="left" disabled={disabled}>
          {button}
        </TooltipTrigger>
      ) : (
        button
      )}
      {badge}
    </div>
  );
}
